import {
  singlePageDataFetcher,
  SinglePageTemplate,
} from "components/templates/SinglePage";

export default SinglePageTemplate;

export async function getServerSideProps(context) {
  const locale = context.locale;
  const query = { slug: "programs" };
  return await singlePageDataFetcher({ query, locale });
}
